import { PropsWithChildren, useEffect, useState } from 'react'
import { UserContext } from './UserContext'
import { useAuthState, useClient } from '@based/sdk/react'
import { User } from '@schema/user'

export const UserProvider = ({ children }: PropsWithChildren) => {
  const client = useClient()
  const authState = useAuthState()
  const [user, setUser] = useState<User | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const isAuthed = !!(authState && authState.userId)

  useEffect(() => {
    if (isAuthed) {
      setIsLoading(true)

      client
        .query('current-user', { userId: authState.userId })
        .get()
        .then((result) => {
          setUser(result)
          setIsLoading(false)
        })
        .catch((error) => {
          console.warn('Failed to fetch user data:', error)
          setUser(null)
          setIsLoading(false)
        })
    } else {
      setUser(null)
      setIsLoading(false)
    }
  }, [client, isAuthed, authState?.userId])

  return (
    <UserContext.Provider
      value={{ user, authState, isAuthenticated: isAuthed, isLoading }}
    >
      {children}
    </UserContext.Provider>
  )
}
